import { useMutation } from '@tanstack/react-query';
import { MutationProps } from 'src/interface/Commons';
import { ResCalFertility } from 'src/interface/HealthcareTools';
import { fetchApiPartner } from 'src/utils/fetch-api';
export interface ICalculateFertility {
  start_date?: string;
  mens_cycle?: number;
  mens_duration?: number;
  hpht?: any;
  pregnancy_week?: any;
}
export interface ResultUniqueLink {
  estimated_birth_results: string;
  estimated_fertilization: string;
  estimated_ready_born: string;
  trimester_1: string;
  trimester_2: string;
  trimester_3: string;
}
export interface IUniqueLink {
  result: ResultUniqueLink[];
}
const useCalculateFertility = ({
  onError,
  onSuccess
}: MutationProps<ResCalFertility>) => {
  return useMutation({
    mutationFn: (payload: ICalculateFertility) => fetchApiPartner({
      url: '/ovulation',
      payload,
      options: {
        method: 'POST'
      }
    }),
    onError: (error: ResCalFertility) => onError?.(error),
    onSuccess: (response: ResCalFertility) => {
      if (response) {
        onSuccess(response);
      }
    }
  });
};
const useCalculateHPL = ({
  onError,
  onSuccess
}: MutationProps<ResCalFertility>) => {
  return useMutation({
    mutationFn: (payload: ICalculateFertility) => fetchApiPartner({
      url: '/pregnancy/hpl',
      payload,
      options: {
        method: 'GET'
      }
    }),
    onError: (error: ResCalFertility) => onError?.(error),
    onSuccess: (response: ResCalFertility) => {
      if (response) {
        onSuccess(response);
      }
    }
  });
};
export { useCalculateFertility, useCalculateHPL };